
import { App, defineAsyncComponent } from 'vue'

import LocalizationLanguageSwitcher from './LanguageSwitcher'
import CityView from './cities/View.vue'

const LocalizationCountries = defineAsyncComponent(() => import('./Countries.vue'))
const CityChangeForm = defineAsyncComponent(() => import('./cities/Form.vue'))
const CityAutoTrigger = defineAsyncComponent(() => import('./cities/AutoTrigger.vue'))

const install = (app: App<Element>, prefix = 'Localization'): void => {
  app
    .component(`${prefix}LanguageSwitcher`, LocalizationLanguageSwitcher)
    .component(`${prefix}Countries`, LocalizationCountries)
    .component(`${prefix}CityView`, CityView)
    .component(`${prefix}CityForm`, CityChangeForm)
    .component(`${prefix}CityAutoTrigger`, CityAutoTrigger)
}

export default {
  install,
}
